import React from 'react';
import { Skeleton } from '@mui/material';

type LoadingChartProps = {
  loading: boolean;
}

const LoadingChart: React.FC<LoadingChartProps> = ({ loading }) => {
  if (!loading) {
    return null;
  }
  return (
    <Skeleton variant="rounded" width={'100%'} height={400} />
  );
};

export default LoadingChart;